import React from 'react';
import PropTypes from 'prop-types';
import { stopPropagation } from '../../utils/listeners';
import { IconSizes } from '../Icons';
import { TagVariants } from './tag-consts';

import * as S from './styled';

const Tag = ({
  className,
  content,
  icon,
  dotColor,
  testId,
  onClose,
  onClick,
  onMouseEnter,
  onMouseLeave,
  variant = TagVariants.CHIP,
  status,
  solid,
  selected,
  clickable,
  maxWidth,
  ellipsis,
  bgColor,
  color
}) => {
  const onClickHandler = onClick
    ? e => {
        e.stopPropagation();
        onClick(e);
      }
    : undefined;
  const onCloseHandler = onClose
    ? e => {
        e.stopPropagation();
        onClose(e);
      }
    : undefined;
  return (
    <S.TagWrapper
      className={className}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      $maxWidth={maxWidth}
      $variant={variant}
      $status={status}
      $solid={solid}
      $selected={selected}
      $bgColor={bgColor}
      $clickable={!!onClick || !!onClose || clickable}>
      <S.TagContent
        data-testid={testId && `value-${testId}`}
        $variant={variant}
        $status={status}
        $solid={solid}
        $color={color}
        $clickable={!!onClick || !!onClose || clickable}
        onClick={onClickHandler}
        $ellipsis={ellipsis}
        onMouseDown={stopPropagation}>
        {!!dotColor && <S.ColoredCircle $color={dotColor} />}
        {typeof icon === 'function' ? icon() : icon}
        {typeof content === 'function' ? content() : content}
      </S.TagContent>
      {!!onClose && (
        <S.CloseIcon
          data-testid={testId && `button-close-${testId}`}
          onClick={onCloseHandler}
          fontSize={IconSizes.XS}
          onMouseDown={stopPropagation}
        />
      )}
    </S.TagWrapper>
  );
};
Tag.propTypes = {
  className: PropTypes.string,
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.node, PropTypes.element]).isRequired,
  dotColor: PropTypes.string,
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.node, PropTypes.element]),
  variant: PropTypes.oneOf(['CHIP', 'MAIN', 'PRIMARY', 'NAKED']),
  status: PropTypes.oneOf(['SUCCESS', 'WARNING', 'ERROR']),
  solid: PropTypes.bool,
  onClick: PropTypes.func,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  onClose: PropTypes.func,
  testId: PropTypes.string,
  selected: PropTypes.bool,
  clickable: PropTypes.bool,
  maxWidth: PropTypes.string,
  ellipsis: PropTypes.bool,
  bgColor: PropTypes.string,
  color: PropTypes.string
};

export default Tag;
